export const HotelService = require('./hotelService');
